import { render, staticRenderFns } from "./JoinCompany.vue?vue&type=template&id=2efe2812"
import script from "./JoinCompany.vue?vue&type=script&lang=js"
export * from "./JoinCompany.vue?vue&type=script&lang=js"
import style0 from "./JoinCompany.vue?vue&type=style&index=0&id=2efe2812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports